import { render } from "./fetch-autocomplete.vue?vue&type=template&id=92b4250a"
import script from "./fetch-autocomplete.vue?vue&type=script&lang=js"
export * from "./fetch-autocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__